import { createSelector } from '@ngrx/store';

import { selectDecoratorsState } from './decorators.selector';

export const getCMTitleValue = createSelector(
  selectDecoratorsState,
  (state): string => state?.cmTitle || ''
);
